module.exports = __webpack_public_path__ + "img/school.a1f20d40.png";